<template lang="html">
  <div class="top-wrapper">
    <div v-if="showHeader" class="title-box pt-4 pb-2">
      <v-btn icon class="back-btn ma-0" @click="$router.back()">
        <v-icon color="#2f0338" x-large>mdi-chevron-left</v-icon>
      </v-btn>
      <div class="font-purple font-bold fa-1_1x sp-sm-space mt-3 text-center">
        {{ title }}
      </div>
    </div>
    <div class="lang-changer" :class="{ 'no-header': !showHeader }">
      <button :class="{ active: lang == 'en' }" @click="lang = 'en'">A</button>
      <button :class="{ active: lang == 'ja' }" @click="lang = 'ja'">あ</button>
    </div>
    <div class="scroll-wrapper hor-padding py-3" :class="{ 'no-header': !showHeader }">
      <perfect-scrollbar
        class="pink-scroll"
        :options="{
          minScrollBarLength: '40px',
        }"
      >
        <div class="hor-padding">
          <transition name="fade-scale" mode="out-in">
            <router-view :lang="lang" />
          </transition>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: 'en',
    };
  },

  computed: {
    showHeader() {
      return (
        this.$route.query['header'] === undefined ||
        this.$route.query['header'] === 'true' ||
        this.$route.query['header'] === 'True'
      );
    },
    title() {
      switch (this.$route.name) {
        case 'info.terms':
          return this.lang == 'en'
            ? 'Terms and Conditions of use'
            : this.lang == 'ja'
            ? '利用規約'
            : '';
        case 'info.privacy':
          return this.lang == 'en'
            ? 'Privacy Policy'
            : this.lang == 'ja'
            ? 'プライバシーポリシー'
            : '';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="css" scoped>
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.2s;
  transform-origin: center;
}
.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
.top-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #fff;
  z-index: 2;
}
.title-box {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0 1px 1px 0 rgba(47, 3, 56, 0.12);
}
.back-btn {
  position: absolute;
  left: 0;
  top: 30px;
}
.lang-changer {
  position: fixed;
  right: 32px;
  top: 90px;
  background-color: #f3f0f3;
  padding: 5px;
  border-radius: 50px;
  z-index: 2;
}
.lang-changer.no-header {
  top: 22px;
}
.lang-changer button {
  width: 35px;
  height: 35px;
  font-size: 24px;
  font-weight: bold;
  color: #2f0338;
  border-radius: 50%;
  outline: none;
}
.lang-changer button.active {
  background-color: #fff;
  color: #b21977;
}
.scroll-wrapper {
  margin-top: 71px;
  height: calc(100% - 71px);
  position: relative;
}
.scroll-wrapper.no-header {
  margin-top: 0;
  height: 100%;
}
.pink-scroll {
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
